import React from 'react';
import { useTranslation } from 'react-i18next';

import { useKioskManager } from '../../../hooks/useKioskManager';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import TextButton from '../textButton/TextButton';
import type { BreadcrumbsProps } from '../types';
import styles from './breadcrumb.module.scss';

type props = {
  items?: BreadcrumbsProps['items'];
  initialState?: boolean;
};

const Breadcrumb: React.FC<props> = ({ items, initialState = false }) => {
  const { kiosk } = useKioskManager();
  const { t } = useTranslation('common');
  const title = t('titles.campusCategories');

  return (
    <div className={`${styles.breadcrumb} ${kiosk && styles[kiosk.model]}`}>
      {initialState ? (
        <TextButton onClick={() => {}} label={title} side={'none'} capitalize />
      ) : (
        <>
          {items?.map((item, index) => {
            const activeItem = index === items.length - 1;
            return !activeItem ? (
              <TextButton
                key={`btn-${item.label}`}
                onClick={item.onClick}
                label={item.label}
                side={'none'}
                underline
                capitalize
              />
            ) : (
              <div
                key={`icon-${item.label}`}
                className={styles.breadcrumb__itemCurrent}
              >
                <Icon icon={IconType.RIGHT} />
                <div className={styles.active}>{item.label}</div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default Breadcrumb;
